import React, { useEffect, useState, useCallback } from "react";
import { Helmet } from "react-helmet";
import { Link, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axios from "axios";

function ViewClient(props) {
  const [title] = useState("Brand Info | Chimera Solutions | Insights");
  const [data, setData] = useState([]);
  const [load, setLoad] = useState(false);
  const location = useLocation();

  const headers = {
    Authorization: props.user.data.usrKey,
    "Content-Type": "application/json",
    Accept: "application/json",
  };

  const outletChange = async (groupData, group, brand, chain) => {
    // Create a copy of the current data to avoid mutating state directly
    const updatedData = [...data];
    const groupIndex = updatedData.findIndex((g) => g._id === groupData._id);

    if (groupIndex !== -1) {
      // Find the brand index
      const brandIndex = updatedData[groupIndex].brands.findIndex(
        (b) => b.braKey === brand.braKey
      );

      if (brandIndex !== -1) {
        // Find the chain index
        const chainIndex = updatedData[groupIndex].brands[
          brandIndex
        ].chains.findIndex((c) => c.chaKey === chain.chaKey);

        if (chainIndex !== -1) {
          // Toggle the chain status in local state first
          updatedData[groupIndex].brands[brandIndex].chains[chainIndex].status =
            updatedData[groupIndex].brands[brandIndex].chains[chainIndex]
              .status === 1
              ? 0
              : 1;

          // Update local state immediately for better UX
          setData(updatedData);

          try {
            // Send update to server
            await axios.put(
              props.chimeraserv.urlPost + "/group/update",
              updatedData[groupIndex],
              { headers }
            );
          } catch (error) {
            console.error("Error updating outlet:", error);
            // Revert the change if API call fails
            updatedData[groupIndex].brands[brandIndex].chains[
              chainIndex
            ].status =
              updatedData[groupIndex].brands[brandIndex].chains[chainIndex]
                .status === 1
                ? 0
                : 1;
            setData(updatedData);
          }
        }
      }
    }
  };

  const valueChange = async (brandData, key) => {
    const updatedBrand = {
      ...brandData,
      status: brandData.status === 1 ? 0 : 1,
    };

    try {
      await axios.put(
        props.chimeraserv.urlPost + "/group/update",
        updatedBrand,
        {
          headers,
        }
      );
      setLoad(false);
      setData([updatedBrand]);
      setLoad(true);
    } catch (error) {
      setLoad(false);
    }
  };

  const loadData = useCallback(async () => {
    try {
      const response = await axios.get(props.chimeraserv.urlGet + "/group/", {
        headers,
      });
      setData(
        response.data.filter((group) =>
          group.brands.find((brand) => brand.braKey === props.match.params.id)
        )
      );
      setLoad(true);
    } catch (error) {
      setData([]);
      setLoad(true);
    }
    // eslint-disable-next-line
  }, [props.chimeraserv.urlGet, props.match.params.id, props.user.data.usrKey]);

  useEffect(() => {
    loadData();
    // eslint-disable-next-line
  }, [loadData]);

  const Loader =
    props.components && props.components.setting && props.components.setting[1]
      ? props.components.setting[1].component
      : () => <div>Loading...</div>;

  return (
    <div className={["custForm", "custView"].join(" ")}>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <div className={["viewTitle"]}>Brand Info</div>
      {!load ? (
        <Loader />
      ) : (
        <div>
          <div className={["form", "fullWidth"].join(" ")}>
            {data.map((group) =>
              group.brands
                .filter((brand) => brand.braKey === props.match.params.id)
                .map((brand, key) => (
                  <div key={key}>
                    <div className={["form-group"]}>
                      <label>Brand Name</label>
                      <div className={["field", "value"].join("_")}>
                        {brand.name}
                      </div>
                    </div>
                    <div className={["form-group"]}>
                      <label>Status</label>
                      <div className={["field", "value"].join("_")}>
                        {brand.status ? "Active" : "Inactive"}
                      </div>
                    </div>
                    {props.user.data.level === 0 ? (
                      <div className={["actions", "actionsAdmin"].join(" ")}>
                        <Link
                          to={
                            location.pathname
                              .split("/")
                              .splice(0, 3)
                              .join("/") +
                            "/main/edit/" +
                            brand.braKey
                          }
                          className={["btn btn-primary"]}
                        >
                          Edit
                        </Link>
                        <button
                          type={"button"}
                          // onClick={() => valueChange(brand, key)}
                          className={["btn", "btn-primary", "disable"].join(
                            " "
                          )}
                        >
                          {brand.status ? "Disable" : "Enable"}
                        </button>
                      </div>
                    ) : (
                      <div />
                    )}
                  </div>
                ))
            )}
          </div>
          <div className={["form", "fullWidth"].join(" ")}>
            {[].concat
              .apply(
                [],
                data.map((group) => ({
                  group: group,
                  brands: group.brands.filter(
                    (brand) => brand.braKey === props.match.params.id
                  ),
                }))
              )
              .map((dataObj, key) => (
                <div key={key}>
                  <div className={["form-group"]}>
                    <label>Brand Key</label>
                    <div className={["field", "value"].join("_")}>
                      {dataObj.brands.find(
                        (brand) => brand.braKey === props.match.params.id
                      )
                        ? dataObj.brands.find(
                            (brand) => brand.braKey === props.match.params.id
                          ).braKey
                        : ""}
                    </div>
                  </div>
                  <div className={["form-group"]}>
                    <label>Outlets</label>
                    <table className={["table", "table-striped"].join(" ")}>
                      <thead>
                        <tr>
                          <th>Brand</th>
                          <th>Outlet</th>
                          <th>Status</th>
                          <th>Chain Key</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {[].concat
                          .apply(
                            [],
                            dataObj.brands.map((brand, braKey) =>
                              brand.chains.map((chain) => ({
                                data: dataObj.group,
                                group: {
                                  index: key,
                                  grpKey: dataObj.group.grpKey,
                                  _id: dataObj.group._id,
                                  name: dataObj.group.name,
                                },
                                brand: {
                                  index: braKey,
                                  braKey: brand.braKey,
                                  name: brand.name,
                                },
                                ...chain,
                              }))
                            )
                          )
                          .map((chain, idx) => (
                            <tr key={idx}>
                              <td>{chain.brand.name}</td>
                              <td>{chain.name}</td>
                              <td>
                                <div className={"name"}>
                                  <div
                                    className={[
                                      "status",
                                      chain.info.status ? "" : "offline",
                                    ].join(" ")}
                                  />
                                  {chain.info.status ? "Online" : "Offline"}
                                </div>
                              </td>
                              <td>{chain.chaKey}</td>
                              <td className={["actions"]}>
                                {props.user.data.level === 0 ? (
                                  <div
                                    className={["actions", "actionsAdmin"].join(
                                      " "
                                    )}
                                  >
                                    <label className="switch">
                                      <input
                                        type="checkbox"
                                        id={chain.chaKey}
                                        checked={!!chain.status}
                                        onChange={() =>
                                          outletChange(
                                            chain.data,
                                            chain.group,
                                            chain.brand,
                                            chain,
                                            key
                                          )
                                        }
                                      />
                                      <span className="slider"></span>
                                    </label>

                                    {/* <div
                                      className={[
                                        "custom-control",
                                        "custom-switch",
                                      ].join(" ")}
                                    >
                                      <input
                                        type={"checkbox"}
                                        className={"custom-control-input"}
                                        id={chain.chaKey}
                                        defaultChecked={
                                          chain.status ? true : false
                                        }
                                        onChange={() =>
                                          outletChange(
                                            chain.data,
                                            chain.group,
                                            chain.brand,
                                            chain,
                                            key
                                          )
                                        }
                                      />
                                      <label
                                        className={"custom-control-label"}
                                        htmlFor={chain.chaKey}
                                      />
                                    </div> */}

                                    <Link
                                      to={
                                        location.pathname
                                          .split("/")
                                          .splice(0, 3)
                                          .join("/") +
                                        "/outlet/edit/" +
                                        chain.chaKey
                                      }
                                    >
                                      <FontAwesomeIcon
                                        className={["icon"].join(" ")}
                                        icon={["fas", "cog"]}
                                      />{" "}
                                      Edit
                                    </Link>
                                  </div>
                                ) : (
                                  <div />
                                )}
                                <Link
                                  to={
                                    location.pathname
                                      .split("/")
                                      .splice(0, 3)
                                      .join("/") +
                                    "/outlet/view/" +
                                    chain.chaKey
                                  }
                                >
                                  <FontAwesomeIcon
                                    className={["icon"].join(" ")}
                                    icon={["fas", "eye"]}
                                  />{" "}
                                  View
                                </Link>
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              ))}
          </div>
        </div>
      )}
    </div>
  );
}

export default ViewClient;
